<template>
  <span>
    <v-navigation-drawer v-model='sidebar' app class='oem-secondary-color'>
      <div class='logo'>
        <v-img :src='logo'
          aspect-ratio='1'
          max-height='40'
          contain
          class='transparent ma-0'
          @click='logoClicked()'
        />
      </div>
      <v-list expand>
        <v-list-group
          :key='setup.title'
          v-model='setup.active'
          class='oem-tertiary-text-color'
          avatar
          no-action
        >
          <v-icon slot='appendIcon'
            :color='notificationColor("full")'
            v-if='!setup.active'>
            {{ `${this.notificationIcon('full')}` }}
          </v-icon>
          <v-icon slot='appendIcon'>
            keyboard_arrow_down
          </v-icon>
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon class='oem-tertiary-text-color'>{{ setup.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title class='oem-tertiary-text-color'>
                  {{ setup.title }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          <v-list-tile>
            <v-list-tile-content>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn
                flat
                class='transparent ma-0'
                @click='$refs.legend.show()'
                icon
                small>
                <v-icon class='oem-text-color'>
                  help_outline
                </v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          <help-notification-legend ref='legend'></help-notification-legend>

          <v-list-tile
            v-for='subItem in setup.items'
            :key='subItem.title'
            :to='subItem.path'
          >
            <v-list-tile-content>
              <v-list-tile-title class='oem-tertiary-text-color'>
                {{ subItem.title }}
              </v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action v-if='subItem.name'>
              <v-icon :color='notificationColor(subItem.name)'>
                {{ notificationIcon(subItem.name) }}
              </v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
        <v-list-group
          v-for='item in analytics'
          :key='item.title'
          v-model='item.active'
          class='oem-tertiary-text-color'
          no-action
        >
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon class='oem-tertiary-text-color'>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title class='oem-tertiary-text-color'>
                  {{ item.title }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>

          <v-list-tile
            v-for='subItem in item.items'
            :key='subItem.title'
            :to='subItem.path'
            class='oem-tertiary-text-color'
          >
            <v-list-tile-content>
              <v-list-tile-title class='oem-tertiary-text-color'>
                {{ subItem.title }}
              </v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon class='oem-tertiary-text-color'>
                {{ subItem.action }}
              </v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
        <v-list-tile
          v-for='item in menuItems'
          :key='item.title'
          :to='item.path'
          class='oem-tertiary-text-color'
        >
          <v-list-tile-action>
            <v-icon class='oem-tertiary-text-color'>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content class='oem-tertiary-text-color'>
            {{ item.title }}
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar class='oem-secondary-color' app>
      <v-toolbar-side-icon
        @click='sidebar = !sidebar'
        dark
        class='hidden-lg-and-up oem-tertiary-text-color'
      >
      </v-toolbar-side-icon>
      <v-toolbar-title
        class='headline text-uppercase hidden-lg-and-up oem-tertiary-text-color'
      >
        <span>{{ title }}</span>
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-btn
          flat
          @click='saveData(false)'
          class='oem-tertiary-text-color'
          v-if='unsavedData'
        >
            <v-icon>
              vertical_align_top
            </v-icon>
            Upload to<br/>meter
        </v-btn>
        <v-btn flat @click='refreshData()' class='oem-tertiary-text-color'>
          <v-icon>
            refresh
          </v-icon>
          Reload
        </v-btn>
        <v-btn flat @click='logoutDialog()' class='oem-tertiary-text-color'>
          <v-icon>
            logout
          </v-icon>
          Logout
        </v-btn>
        <msg-dialog
          ref='refreshDialog'
          v-bind:title='`Confirm`'
          v-bind:msg='refreshText'
        />
        <msg-dialog
          ref='logoutDialog'
          v-bind:title='`Confirm`'
          v-bind:msg='logoutText'
        />
        <v-dialog persistent v-model='d29sZgDialog' max-width='360px'>
          <div v-html=image></div>
        </v-dialog>
        <v-dialog v-model='dialog' max-width='500px'>
          <v-card>
            <v-card-title class='headline font-weight-regular oem-color'
              >Can't upload data
            </v-card-title>

            <v-card-text>
              {{ errText }}
              <v-list-tile
                v-for='(item, index) in invalidCts'
                :key='index'
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{ `CT${item.channel - 5}` }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
               <v-list-tile
                v-for='(input, index) in invalidInputs'
                :key='index'
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{ `Input ${input.id + 1}` }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class='oem-button' flat @click='dialog = false'>Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model='updateDialog' persistent max-width='550px'>
          <v-card class="mx-auto">
            <v-card-title class='headline font-weight-regular oem-color'>
              Reload
            </v-card-title>
            <v-card-text>
              <span class='oem-text-color'>
                <div class="d-flex ma-3">
                  {{ updateText }}
                  <v-spacer></v-spacer>
                  <hollow-dots-spinner
                    :animation-duration="1000"
                    :dot-size="15"
                    :dots-num="3"
                    color= "var(--primary-color)"
                    class="pl-5"
                  ></hollow-dots-spinner>
                </div>
              </span>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-toolbar-items>
    </v-toolbar>
    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :top='true'
    >
      {{ snackbarText }}
      <v-btn
        class='oem-color-text'
        flat
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-dialog v-model='timeoutDialog' max-width='500px'>
      <v-card>
        <v-card-title class='headline font-weight-regular oem-color'
          >User inactivity detected
        </v-card-title>
        <v-card-text>
          You are about to timeout in {{ timeoutTime }} second(s).
          <div v-if='unsavedData'>
            Your unsaved data will be lost.
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <msgDialog
      ref='dialogDeleteTrendData'
      v-bind:title='`Confirm`'
      v-bind:msg='getMappingChangeWarningMessage()'
    />
    <div class='back fill-height' :style='backgroundStyle'>
    <router-view></router-view>
    </div>
  </span>
</template>

<script>
import { HollowDotsSpinner } from 'epic-spinners';
import msgDialog from './BaseDialog.vue';
import helpNotificationLegend from './BaseNotificationLegend.vue';
import * as auth from '../auth';
// import router from '../routes';
import { EventBus } from '../bus';

const setraLogo = require('../assets/img/setra-logo.svg');
const flukeLogo = require('../assets/img/fluke.svg');
const siemensLogo = require('../assets/img/siemens.svg');
const d29sZg = require('../assets/img/d29sZg.json');

export default {
  name: 'Navigation',

  components: {
    msgDialog,
    helpNotificationLegend,
    HollowDotsSpinner,
  },
  created() {
    EventBus.$on('force-mapping', (data) => {
      // You can then call your method attached to this component here
      this.forceUploadMappingChanges();
    });
  },

  data() {
    return {
      storeState: this.$store.state,
      right: null,
      sidebar: true,
      title: 'Setra powermeter',
      start: { title: 'Login', path: '/login', icon: 'fingerprint' },
      setup:
        {
          title: 'Setup',
          path: '',
          icon: 'settings',
          active: true,
          items: [
            { title: 'General settings', path: '/general', name: 'general' },
            { title: 'Voltage inputs', path: '/voltage', name: 'voltage' },
            { title: 'Load setup', path: '/load', name: 'load' },
            { title: 'CT inputs', path: '/ct', name: 'ct' },
            { title: 'Communications', path: '/communications', name: 'communications' },
            { title: 'Pulse IO setup', path: '/pulse', name: 'pulse' },
            { title: 'Alarm setup', path: '/alarm', name: 'alarm' },
            { title: 'Installation report', path: '/report', name: 'report' },
          ],
        },
      analytics: [
        {
          title: 'Power analytics',
          path: '',
          icon: 'power',
          items: [
            { title: 'Trends', path: '/trends' },
            /*
            { title: 'Harmonics', path: '/harmonics' },
            { title: 'Waveform', path: '/waveform' },
*/
            { title: 'Odometer', path: '/odometer' },
          ],
        },
      ],
      menuItems: [
        { title: 'Event log', path: '/log', icon: 'event' },
        { title: 'Alarm status', path: '/alarmlog', icon: 'notification_important' },
        { title: 'System', path: '/system', icon: 'settings_system_daydream' },
        { title: 'Export configuration', path: '/export', icon: 'import_export' },
        { title: 'Help', path: '/help', icon: 'help' },
      ],
      refreshText:
        'Are you sure you want to pull setup from the meter? '
        + 'This will undo any unsaved changes.',
      logoutText:
        'Are you sure you want to logout? '
        + 'This will undo any unsaved changes.',
      errText: '',
      dialog: false,
      invalidCts: [],
      invalidInputs: [],
      snackbar: false,
      snackbarText: '',
      timeoutDialog: false,
      timeoutText: '',
      timeoutTime: 10,
      clickCounter: 0,
      clickTimeout: null,
      ieVersion: false,
      updateDialog: false,
      updateText: '',
    };
  },

  computed: {
    image() {
      return atob(d29sZg.data);
    },
    d29sZgDialog() {
      if (this.clickCounter >= 10) {
        this.storeState.debugMode = true; // eslint-disable-line vue/no-side-effects-in-computed-properties
        return true;
      }
      return false;
    },
    backgroundStyle() {
      if (this.storeState.style === 'fluke') {
        document.documentElement.style.setProperty('--primary-color', '#ffc20e');
        document.documentElement.style.setProperty('--secondary-color', '#212121');
        document.documentElement.style.setProperty('--tertiary-color', '#ffc20e');
        document.documentElement.style.setProperty('--primary-text-color', '#000');
        document.documentElement.style.setProperty('--secondary-text-color', '#000');
        document.documentElement.style.setProperty('--tertiary-text-color', '#fff');
        document.documentElement.style.setProperty('--quaternary-text-color', '#000');
        return { 'background-color': '#eaeaea' };
      }

      if (this.storeState.style === 'siemens') {
        document.documentElement.style.setProperty('--primary-color', '#099');
        document.documentElement.style.setProperty('--secondary-color', '#ebf0f5');
        document.documentElement.style.setProperty('--tertiary-color', '#dee5ec');
        document.documentElement.style.setProperty('--primary-text-color', '#fff');
        document.documentElement.style.setProperty('--secondary-text-color', '#697882');
        document.documentElement.style.setProperty('--tertiary-text-color', '#697882');
        document.documentElement.style.setProperty('--quaternary-text-color', '#697882');
        return { 'background-color': '#fff' };
      }

      document.documentElement.style.setProperty('--primary-color', '#1d428a');
      document.documentElement.style.setProperty('--secondary-color', '#f3f4f8');
      document.documentElement.style.setProperty('--tertiary-color', '#c7d0e1');
      document.documentElement.style.setProperty('--primary-text-color', '#fff');
      document.documentElement.style.setProperty('--secondary-text-color', '#1d428a');
      document.documentElement.style.setProperty('--tertiary-text-color', '#1d428a');
      document.documentElement.style.setProperty('--quaternary-text-color', '#8597bd');

      return { 'background-color': '#fafafa' };
    },
    logo() {
      if (this.storeState.style === 'fluke') {
        return flukeLogo;
      }

      if (this.storeState.style === 'siemens') {
        return siemensLogo;
      }

      return setraLogo;
    },
    unsavedData() {
      if (this.storeState.voltageDirty) {
        return true;
      }
      if (this.storeState.loadDirty) {
        return true;
      }
      if (this.storeState.ctDirty) {
        return true;
      }
      if (this.storeState.pulseDirty) {
        return true;
      }
      if (this.storeState.communicationsDirty) {
        return true;
      }
      if (this.storeState.generalDirty) {
        return true;
      }
      if (this.storeState.timeUpdated) {
        return true;
      }
      if (this.storeState.alarmsDirty) {
        return true;
      }
      if (this.storeState.reportDirty) {
        return true;
      }
      return false;
    },
  },

  methods: {
    refreshData() {
      if (this.unsavedData) {
        this.$refs.refreshDialog
          .pop()
          .then(() => {
            this.$store.refreshData();
          })
          .catch(() => {});
      } else {
        this.$store.refreshData();
      }
    },
    forceUploadMappingChanges() {
      // force Uploading the changes here
      this.saveData(true);
    },
    getMappingChangeWarningMessage() {
      if (this.storeState.data.pulse.filter(p => p.out && p.active).length !== 0) {
        return 'When changing the mapping (Voltage inputs / Load setup / CT inputs), all existing trend data will be removed and the pulse out configuration will be reset to default. Are your sure you want to continue?';
      }
      return 'When changing the mapping (Voltage inputs / Load setup / CT inputs), all existing trend data will be removed. Are your sure you want to continue?';
    },
    inputsValid() {
      let configuredInputs = true;
      const invalidInputs = [];
      Object.values(this.storeState.data.inputs).forEach((input) => {
        if (input.used && !input.active) {
          configuredInputs = false;
          invalidInputs.push(input);
        }
      });
      return [configuredInputs, invalidInputs];
    },
    ctsValid() {
      let configuredCts = true;
      const invalidCts = [];
      Object.values(this.storeState.data.allCts).forEach((ct) => {
        if (!ct.unsaved && ct.active) {
          configuredCts = false;
          invalidCts.push(ct);
        }
      });
      return [configuredCts, invalidCts];
    },
    saveData(isForceMapping) {
      const ctsValid = this.ctsValid();
      const inputsValid = this.inputsValid();
      // eslint-disable-next-line
      this.invalidCts = ctsValid[1];
      // eslint-disable-next-line
      this.invalidInputs = inputsValid[1];
      this.snackbarText = '';
      this.errText = '';
      let allValid = true;

      if (!this.storeState.generalValid) {
        this.errText += 'General settings page is not valid.\n';
        allValid = false;
        this.dialog = true;
      }

      if (!this.storeState.communicationsValid) {
        this.errText += 'Communications page is not valid.\n';
        allValid = false;
        this.dialog = true;
      }

      if (!this.storeState.pulseValid) {
        this.errText += 'Pulse IO page is not valid.\n';
        allValid = false;
        this.dialog = true;
      }

      if (!this.storeState.alarmsValid) {
        this.errText += 'Alarm setup page is not valid.\n';
        allValid = false;
        this.dialog = true;
      }

      if (!this.storeState.reportValid) {
        this.errText += 'Installation report page is not valid.\n';
        allValid = false;
        this.dialog = true;
      }

      if (!ctsValid[0] || !inputsValid[0]) {
        this.errText += 'Not all Inputs and CT\'s are unsaved or used.'
        + 'The following inputs/CT\'s are incorrect:';
        this.dialog = true;
        allValid = false;
      }
      if (allValid) {
        const this2 = this;
        const saveAllButMapping = function () {
          if (this2.storeState.generalDirty) {
            this2.$store.saveInfo()
              .then(() => {
                this2.snackbarText += 'Successfully saved device info. ';
                this2.$store.addEventLog('Saved device info to device');
                this2.snackbar = true;
              })
              .catch((err) => {
                this2.snackbarText += `Failed to save device info: ${err}. `;
                this2.$store.addEventLog(`Failed to save device info to device. ${err}`);
                this2.snackbar = true;
              });
          }
          if (this2.storeState.communicationsDirty) {
            this2.$store.saveEthernet()
              .then(() => {
                this2.snackbarText += 'Successfully saved ethernet settings. ';
                this2.$store.addEventLog('Saved ethernet configuration to device');
                this2.snackbar = true;
              })
              .catch((err) => {
                this2.snackbarText += `Failed to save ethernet settings: ${err}. `;
                this2.$store.addEventLog(`Failed to save ethernet configuration to device. ${err}`);
                this2.snackbar = true;
              });
            this2.$store.saveCommunication()
              .then(() => {
                this2.snackbarText += 'Successfully saved communications settings. ';
                this2.$store.addEventLog('Saved communications configuration to device');
                this2.snackbar = true;
              })
              .catch((err) => {
                this2.snackbarText += `Failed to save communications settings: ${err}. `;
                this2.$store.addEventLog(`Failed to save communications configuration to device. ${err}`);
                this2.snackbar = true;
              });
          }
          if (this2.storeState.timeUpdated) {
            this2.$store.saveTime()
              .then(() => {
                this2.snackbarText += 'Successfully saved time. ';
                this2.$store.addEventLog('Saved time to device');
                this2.snackbar = true;
              })
              .catch((err) => {
                this2.snackbarText += `Failed to save time: ${err}. `;
                this2.$store.addEventLog(`Failed to save time to device. ${err}`);
                this2.snackbar = true;
              });
            this2.storeState.timeUpdated = false;
          }
          if (this2.storeState.pulseDirty) {
            this2.$store.savePulse()
              .then(() => {
                this2.snackbarText += 'Successfully saved pulse settings. ';
                this2.$store.addEventLog('Saved pulse configuration to device');
                this2.snackbar = true;
              })
              .catch((err) => {
                this2.snackbarText += `Failed to save pulse settings: ${err}. `;
                this2.$store.addEventLog(`Failed to save pulse configuration to device. ${err}`);
                this2.snackbar = true;
              });
          }
          if (this2.storeState.alarmsDirty) {
            this2.$store.saveAlarms()
              .then(() => {
                this2.snackbarText += 'Successfully saved alarms. ';
                this2.$store.addEventLog('Saved alarm configuration to device');
                this2.snackbar = true;
              })
              .catch((err) => {
                this2.snackbarText += `Failed to save alarms: ${err}. `;
                this2.$store.addEventLog(`Failed to save alarm configuration to device. ${err}`);
                this2.snackbar = true;
              });
          }
          if (this2.storeState.reportDirty) {
            this2.$store.saveReport()
              .then(() => {
                this2.snackbarText += 'Successfully saved report. ';
                this2.$store.addEventLog('Saved report configuration to device');
                this2.snackbar = true;
              })
              .catch((err) => {
                this2.snackbarText += `Failed to save report: ${err}. `;
                this2.$store.addEventLog(`Failed to save report configuration to device. ${err}`);
                this2.snackbar = true;
              });
          }
        };

        if (isForceMapping) {
          if (this2.storeState.voltageDirty
              || this2.storeState.loadDirty
              || this2.storeState.ctDirty) {
            this2.$store.saveMapping()
              .then(() => {
                this2.snackbarText += 'Successfully saved mapping. ';
                this2.$store.addEventLog('Saved mapping to device');
                this2.snackbar = true;
                saveAllButMapping();
              })
              .catch((err) => {
                this2.snackbarText += `Failed to save mapping: ${err}. `;
                this2.$store.addEventLog(`Failed to save mapping to device. ${err}`);
                this2.snackbar = true;
                saveAllButMapping();
              });
          }
        } else {
          if (this2.storeState.voltageDirty
              || this2.storeState.loadDirty
              || this2.storeState.ctDirty) {
            this2.$refs.dialogDeleteTrendData
              .pop()
              .then(() => {
                if (this2.storeState.voltageDirty
                    || this2.storeState.loadDirty
                    || this2.storeState.ctDirty) {
                  this2.$store.saveMapping()
                    .then(() => {
                      this2.snackbarText += 'Successfully saved mapping. ';
                      this2.$store.addEventLog('Saved mapping to device');
                      this2.snackbar = true;
                      // // Remove pulse out config
                      // Object.values(this2.storeState.data.pulse).forEach((pulse) => {
                      //   if (pulse.active && pulse.out) {
                      //     pulse.active = false;
                      //     pulse.type = -1;
                      //     pulse.param = -1;
                      //     pulse.loadId = -1;
                      //     this2.storeState.pulseDirty = true;
                      //   }
                      // });
                      saveAllButMapping();
                    })
                    .catch((err) => {
                      this2.snackbarText += `Failed to save mapping: ${err}. `;
                      this2.$store.addEventLog(`Failed to save mapping to device. ${err}`);
                      this2.snackbar = true;
                      saveAllButMapping();
                    });
                }
              })
              .catch(() => {});
          } else {
            saveAllButMapping();
          }
        }
      }
      if (this.storeState.overlappingAlarmsDirty) {
        this.updateText = 'Reloading alarm configuration. Please wait.';
        this.updateDialog = true;
        this.$timer.start('downloadAlarmLogs');
      }
    },
    downloadAlarmLogs() {
      this.$store.refreshData();
      this.$timer.start('refreshAlarmData');
      this.$timer.stop('downloadAlarmLogs');
    },
    refreshAlarmData() {
      this.$store.refreshData();
      this.updateDialog = false;
      this.updateText = '';
      this.$timer.stop('refreshAlarmData');
    },
    close() {
      this.updateDialog = false;
      this.updateText = '';
    },
    timeout() {
      this.timeoutTime -= 1;
      if (this.timeoutTime < 0) {
        this.timeoutTime = 0;
      }
      if (this.storeState.updatingFirmware === true) {
        this.timeoutTime = 30;
      } else if (this.timeoutTime === 0) {
        this.$store.addEventLog('Logging out due to inactivity');
        this.logout();
      }
    },
    logoutDialog() {
      this.$refs.logoutDialog
        .pop()
        .then(() => {
          this.logout();
        })
        .catch(() => {});
    },
    logout() {
      this.$store.addEventLog('User logout');
      auth.clearAccessToken();
      this.$router.push({ name: 'login' });
    },
    configurationState(name) {
      if (name === 'full') {
        let state = 0;
        Object.values(this.setup.items).forEach((item) => {
          state = Math.max(this.configurationState(item.name), state);
        });
        return state;
      }
      const saved = 0;
      const unsaved = 1;
      const warning = 2;
      const error = 3;
      let state = 0;
      if (name === 'voltage') {
        Object.values(this.storeState.data.inputs).forEach((input) => {
          if (this.storeState.mappingSaved && !this.storeState.voltageDirty) {
            state = Math.max(state, saved);
          } else {
            state = Math.max(state, unsaved);
          }
          if (input.used && !(input.active && input.service !== 0)) {
            state = Math.max(state, error);
          } else if (!input.used && (input.active && input.service !== 0)) {
            // state = Math.max(state, warning); // A voltage input that has no attached loads should not generate a warning in the menu
          }
        });
      }
      if (name === 'ct' || name === 'load') {
        Object.values(this.storeState.data.allCts).forEach((ct) => {
          if (ct.active && ct.unsaved) {
            if (this.storeState.mappingSaved && !this.storeState.loadDirty && name === 'load') {
              state = Math.max(state, saved);
            } else if (this.storeState.mappingSaved && !this.storeState.ctDirty && name === 'ct') {
              state = Math.max(state, saved);
            } else {
              state = Math.max(state, unsaved);
            }
          } else if (ct.active && !ct.unsaved) {
            state = Math.max(state, error);
          } else if (!ct.active && ct.unsaved) {
            state = Math.max(state, warning);
          }
        });
      }
      if (name === 'load') {
        // If Bacnet is enabled, check if the VDI is already set for loads
        // if not, set warning state.
        if (this.storeState.data.communications.type === 'bac_ip'
          || this.storeState.data.communications.type === 'bac_mstp') {
          Object.values(this.storeState.data.loads).forEach((load) => {
            if (!this.storeState.communicationsDirty) {
              state = Math.max(state, saved);
            } else if (load.vdi === undefined || load.vdi === '') {
              state = Math.max(state, warning);
            }
          });
        }
      }
      if (name === 'general') {
        if (!this.storeState.generalValid) {
          return error;
        }
        if (this.storeState.generalDirty || this.storeState.timeUpdated) {
          return unsaved;
        }
        if (this.storeState.generalSaved) {
          return saved;
        }
        return null;
      }
      if (name === 'pulse') {
        if (!this.storeState.pulseValid) {
          return error;
        }
        if (this.storeState.pulseDirty) {
          return unsaved;
        }
        if (this.storeState.pulseSaved) {
          return saved;
        }
        return null;
      }
      if (name === 'communications') {
        if (!this.storeState.communicationsValid) {
          return error;
        }
        if (this.storeState.communicationsDirty) {
          return unsaved;
        }
        if (this.storeState.communicationsSaved) {
          return saved;
        }
        return null;
      }
      if (name === 'alarm') {
        if (!this.storeState.alarmsValid) {
          return error;
        }
        if (this.storeState.alarmsDirty) {
          return unsaved;
        }
        if (this.storeState.alarmsSaved) {
          return saved;
        }
        return null;
      }
      if (name === 'report') {
        if (!this.storeState.reportValid) {
          return error;
        }
        if (this.storeState.reportDirty) {
          return unsaved;
        }
        if (this.storeState.reportSaved) {
          return saved;
        }
        return null;
      }
      return state;
    },
    notificationIcon(name) {
      const state = this.configurationState(name);
      if (state === 3) {
        return 'report';
      }
      if (state === 2) {
        return 'warning';
      }
      if (state === 1) {
        return 'vertical_align_top';
      }
      if (state === 0) {
        return 'check';
      }
      return '';
    },
    notificationColor(name) {
      const state = this.configurationState(name);

      if (state === 3) {
        return 'red darken-2';
      }
      if (state === 2) {
        return 'orange darken-2';
      }
      if (state === 1) {
        return 'orange darken-2';
      }
      if (state === 0) {
        return 'green darken-2';
      }
      return '';
    },
    detectIE() {
      const ua = window.navigator.userAgent;

      const trident = ua.indexOf('Trident/');
      if (trident > 0) {
        // IE 11 => return version number
        const rv = ua.indexOf('rv:');
        const version = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        // console.log(`Detected Internet Explorer version ${version}`);
        this.ieVersion = version;
      }
    },
    logoClicked() {
      this.clickCounter += 1;
      clearTimeout(this.clickTimeout);
      // eslint-disable-next-line
      this.clickTimeout = setTimeout(function(){this.clickCounter = 0}.bind(this), 2000);
    },
  },
  onIdle() {
    if (this.storeState.debugMode !== true) {
      this.timeoutDialog = true;
      this.timeoutTime = 30;
      this.$timer.restart('timeout');
    }
  },
  onActive() {
    this.timeoutDialog = false;
    this.$timer.stop('timeout');
  },
  timers: {
    timeout: { time: 1000, repeat: true },
    downloadAlarmLogs: { time: 3000, repeat: false, autostart: false },
    refreshAlarmData: { time: 3000, repeat: false, autostart: false },
  },
  mounted() {
    this.$store.refreshData();
    this.$store.addEventLog('User login');
  },
  beforeMount() {
    this.detectIE();
  },
};
</script>
<style>
.verticalLine {
  border-left: thin solid rgba(0,0,0,.2);
}
#d29sZg {
  width: 360px;
  height: 360px;
  background-color: white;
}

.logo {
  background-color: var(--primary-color) !important;
  height: 64px;
  display: flex;
  align-items: center;
}

</style>
